module.exports = __webpack_public_path__ + "img/pass2025.9cf2705e.png";